
import { SearchParamsType } from "../../../Masters/insuranceMasters/InsurancePlan/Types";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { UserListType } from "./types";
import api from "@services/apiList";
import instance from "@services/services";

const {SettingsApi} = api
export const getLogHistory = async (params:SearchParamsType):Promise<ResponseType<{items:UserListType[],totalcount:number}>>=>{
    const result = await instance.post(`${SettingsApi.getUserLog}`,params);
    return result.data;
}



